import PeopleIcon from '@material-ui/icons/People';
import { DepartmentCreateView } from './views/department-create.view';
import { DepartmentEditView } from './views/department-edit.view';

export default {
  create: DepartmentCreateView,
  edit: DepartmentEditView,
  icon: PeopleIcon,
};
